import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class SectorService extends ServiceCRUD {
  constructor() {
    super('/api/centrosdecusto');
  }
}

export default new SectorService();
